import React from "react";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import axios from "axios";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Danger from "components/Typography/Danger.jsx";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Footer from "components/Footer/Footer.jsx";
import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {getApiHeaders} from "../../assets/helpers/apiHelper";
import {setSessionOnLogin} from "../../assets/helpers/loginHelper";

import { API_ROOT } from 'api-config';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      email: "",
      password: "",
      responseMessage: "",
      loginButtonDisabled: false
    };

  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    if (this.state.email && this.state.password) {
      this.setState({
        responseMessage: 'logging in',
        loginButtonDisabled: true
      })
      const loginData = {
        username: this.state.email,
        password: this.state.password
      }

      axios.post(`${API_ROOT}/auth/login/`, loginData, { headers: getApiHeaders() })
        .then(res => this.handleLoginResponse(res.data));
    } else {
      this.setState({
        responseMessage: 'Please enter a username and password'
      })
    }
  }
  handleLoginResponse(res) {
    if (this._isMounted) {
      if (res.message) {
        this.setState({
          responseMessage: res.message,
          loginButtonDisabled: false
        });
      } else {
        setSessionOnLogin(res)
        if (res.needNewPassword === true) {
          window.location = '/enterNewPassword'
        } else {
          window.location.reload();
        }

      }
    }
  }

  pingBackend = () => {
    // Send a health check ping to the backend to warm up the instance
    // This reduces login time for users on cold instances (e.g., after auto-scaling to zero)
    try {
      // Use a simple HEAD request to minimize bandwidth
      // Don't include credentials to avoid CORS issues
      axios.head(`${API_ROOT}/auth/ping/`, {
        timeout: 5000  // 5 second timeout to avoid blocking the UI
      }).catch(() => {
        // Silently fail - this is just a warmup ping
        console.log('Backend warmup ping sent (timeout or error is OK)');
      });
    } catch (error) {
      // Silently fail - don't show errors to user
      console.log('Backend warmup ping failed (this is OK)');
    }
  }

  componentDidMount() {
    this._isMounted = true;

    // Ping the backend to warm up the instance
    // This helps reduce login time when the backend has scaled down to zero
    this.pingBackend();

    //a member may be coming from a link with an invitation code
    //if so, we want to store the code for use after they log in
    const params = new URLSearchParams(this.props.location.search);
    sessionStorage.setItem('invitationCode', params.get('invitationCode'));
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }



  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <PreLoginHeader />
        <GridContainer justifyContent="center">

          <GridItem xs={12} sm={6} md={4}>
            <form onSubmit={this.handleSubmit}>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="cirrusBlue"
                >
                  <h4 className={classes.cardTitle}>Log in</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="my Email..."
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleChange,
                      autoFocus: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}
                  />
                  <CustomInput
                    labelText="Password"
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: this.handleChange,
                      type: "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      )
                    }}
                  />
                  <div className={classes.center}>
                    <Danger><span id="loginStatusMessage">{this.state.responseMessage}</span></Danger>
                  </div>
                </CardBody>
                <div className={classes.justifyContentCenter}>
                  <Button id="loginButton" color="cirrusBlue" simple size="lg" block type="submit" disabled={this.state.loginButtonDisabled}>
                    log in
                  </Button>
                </div>
                <CardFooter className={classes.justifyContentCenter}>
                  Forgot your password?&nbsp;<Link id="resetPasswordLink" className={classes.linkClass} to="/resetPassword">Reset it here.</Link>
                </CardFooter>
                <CardFooter className={classes.justifyContentCenter}>
                  Don't have an account?&nbsp;<Link id="signupLink" className={classes.linkClass} to="/signup">Sign up here.</Link>
                </CardFooter>
              </Card>
            </form>
          </GridItem>

        </GridContainer>
        <Footer fluid />
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(LoginPage);
